module.exports = __webpack_public_path__ + "static/img/slide_5.2678809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_5.png
// module id = ndIq
// module chunks = 0